<div class="card max-w-md mx-auto mt-8">
  <div class="card-body p-8">
    <h2 class="text-2xl font-bold mb-6 text-gray-900 dark:text-gray-100">
      Create FIN CEN Report
    </h2>

    <form [formGroup]="reportForm" (ngSubmit)="createReport()" class="space-y-6">
      <!-- Date Selection -->
      <div class="space-y-2">
        <label 
          for="quarter-date" 
          class="block text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          Choose a date:
        </label>
        <select
          id="quarter-date"
          formControlName="selectedDate"
          class="form-select w-full px-3 py-2 border border-gray-300 dark:border-gray-600 
                 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
                 focus:border-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100"
          [disabled]="isLoading"
        >
          <option value="" disabled>Select a quarter date</option>
          <option *ngFor="let item of quarterDates" [value]="item.date">
            {{ item.display }}
          </option>
        </select>
      </div>

      <!-- Submit Button -->
      <div class="flex justify-center">
        <button
          type="submit"
          [disabled]="reportForm.invalid || isLoading"
          class="px-6 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 
                 border border-gray-300 dark:border-gray-600 rounded shadow-sm 
                 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none 
                 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                 disabled:opacity-50 disabled:cursor-not-allowed
                 transition-colors duration-200"
        >
          <span *ngIf="!isLoading">Create Report</span>
          <span *ngIf="isLoading" class="flex items-center justify-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-900 dark:text-gray-100" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Creating...
          </span>
        </button>
      </div>
    </form>

    <!-- No Matches Message -->
    <div
      *ngIf="noMatchesMessage"
      class="mt-6 p-3 rounded-md border border-green-300 bg-green-50 text-green-800 text-sm text-center
             dark:border-green-700 dark:bg-green-900/30 dark:text-green-300"
    >
      {{ noMatchesMessage }}
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading && quarterDates.length === 0" class="text-center py-4">
      <svg class="animate-spin mx-auto h-8 w-8 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <p class="text-sm text-gray-600 dark:text-gray-400 mt-2">Loading dates...</p>
    </div>
  </div>
</div>

